import { SvgIcon } from "@mui/material";
import React from "react";

export default function PersonIcon({ ...props }) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.0002 12C14.6465 12 16.7918 9.76142 16.7918 7C16.7918 4.23858 14.6465 2 12.0002 2C9.3538 2 7.2085 4.23858 7.2085 7C7.2085 9.76142 9.3538 12 12.0002 12Z" />
      <path d="M11.9998 14.5C7.19857 14.5 3.28857 17.86 3.28857 22C3.28857 22.28 3.49941 22.5 3.76774 22.5H20.2319C20.5002 22.5 20.7111 22.28 20.7111 22C20.7111 17.86 16.8011 14.5 11.9998 14.5Z" />
    </SvgIcon>
  );
}
